import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import identityService from '../../services/identityService';

const CACHE_DURATION = 10 * 60 * 1000; // 5 minutes

// Async thunk for fetching stats
export const fetchStats = createAsyncThunk(
  'stats/fetchStats',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { lastFetched } = getState().stats;
      const now = Date.now();

      // Return cached data if still valid
      if (lastFetched && now - lastFetched < CACHE_DURATION) {
        return { cached: true };
      }

      const response = await identityService.getStats();
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const statsSlice = createSlice({
  name: 'stats',
  initialState: {
    data: {
      total: 0,
      human_identities: 0,
      non_human_identities: 0,
      risk_stats: {
        high: 0,
        medium: 0,
        low: 0,
        risk_identities: 0,
        safe: 0,
      },
    },
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {
    clearStats: (state) => {
      state.data = {
        total: 0,
        human_identities: 0,
        non_human_identities: 0,
        risk_stats: {
          high: 0,
          medium: 0,
          low: 0,
          risk_identities: 0,
          safe: 0,
        },
      };
      state.lastFetched = null;
    },
    invalidateCache: (state) => {
      state.lastFetched = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchStats.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchStats.fulfilled, (state, action) => {
        state.loading = false;
        if (!action.payload.cached) {
          state.data = action.payload;
          state.lastFetched = Date.now();
        }
      })
      .addCase(fetchStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearStats, invalidateCache } = statsSlice.actions;
export default statsSlice.reducer;